import Chart from 'chart.js/auto';

/**
 * ChartManager: Handles Chart.js instances in isolation
 */
export const ChartManager = {
    charts: {},

    /**
     * Create a line chart
     * @param {string} canvasId - DOM ID of the canvas
     * @param {object} data - { labels: [], datasets: [] }
     * @param {string} title - Chart title
     */
    createLineChart: (canvasId, data, title, color = '#6366f1') => {
        const ctx = document.getElementById(canvasId);
        if (!ctx) return;

        // Destroy existing chart if any
        if (ChartManager.charts[canvasId]) {
            ChartManager.charts[canvasId].destroy();
        }

        ChartManager.charts[canvasId] = new Chart(ctx, {
            type: 'line',
            data: {
                labels: data.labels,
                datasets: [{
                    label: title,
                    data: data.values,
                    borderColor: color,
                    backgroundColor: color + '20', // Transparent fill
                    borderWidth: 2,
                    tension: 0.4, // Smooth curves
                    fill: true,
                    pointRadius: 3,
                    pointHoverRadius: 6
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        titleColor: '#fff',
                        bodyColor: '#fff',
                        borderColor: 'rgba(255, 255, 255, 0.1)',
                        borderWidth: 1
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        grid: {
                            color: 'rgba(0, 0, 0, 0.05)'
                        },
                        border: {
                            display: false
                        }
                    },
                    x: {
                        grid: {
                            display: false
                        }
                    }
                },
                interaction: {
                    mode: 'nearest',
                    axis: 'x',
                    intersect: false
                }
            }
        });
    },

    /**
     * Create a bar chart
     */
    createBarChart: (canvasId, data, title, color = '#3b82f6') => {
        const ctx = document.getElementById(canvasId);
        if (!ctx) return;

        if (ChartManager.charts[canvasId]) {
            ChartManager.charts[canvasId].destroy();
        }

        ChartManager.charts[canvasId] = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: data.labels,
                datasets: [{
                    label: title,
                    data: data.values,
                    backgroundColor: color,
                    borderRadius: 4,
                    barThickness: 'flex',
                    maxBarThickness: 30
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        grid: { color: 'rgba(0, 0, 0, 0.05)' },
                        border: { display: false }
                    },
                    x: {
                        grid: { display: false }
                    }
                }
            }
        });
    },

    destroyAll: () => {
        Object.values(ChartManager.charts).forEach(chart => chart.destroy());
        ChartManager.charts = {};
    }
};
